import { useEffect, type ReactNode } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { setCsrfToken } from "./api/client";
import { useMe, useSessionExpiryGuard } from "./hooks/useAuth";
import { AppShell } from "./components/AppShell";
import { LoginPage } from "./pages/LoginPage";


function RequireAuth({ children }: { children: ReactNode }) {
  const me = useMe();
  const location = useLocation();

  useEffect(() => {
    if (me.data) setCsrfToken(me.data.csrfToken);
  }, [me.data]);

  if (me.isLoading) {
    return <div className="page-center muted">Loading…</div>;
  }
  if (me.isError || !me.data) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }
  return <>{children}</>;
}

export function App() {
  useSessionExpiryGuard();
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/*" element={<RequireAuth><AppShell /></RequireAuth>} />
    </Routes>
  );
}



